
import ExternalModal from './external-modal.vue'
export default {
  components: {
    ExternalModal
  },
  props: {
    href: {type: String, required: true}
  },
  methods: {
    openModal(){
      this.$refs.modal.open()
    }
  }
}
